module.exports = __webpack_public_path__ + "img/gongzhong.33cc2476.jpg";